/**
 * This hook is used to handle the drop event for the steps & operations in the test draft view.
 */

import type { DragDropProvider } from '@dnd-kit/react';
import type { ComponentProps } from 'react';
import { useHandleMoveTestStep } from './useHandleMoveTestStep';
import { useHandleMoveOperation } from './useHandleMoveOperation';
import { useLiveStateManager } from '../useLiveStateManager';

// TODO: disable dropping when some other active editing (e.g. dropping) is in progress
export function useHandleOnDrop({ testContentId }: { testContentId: string }) {
  const { handleMoveOperation, isMoving: isMovingOperation } = useHandleMoveOperation({ testContentId });
  const { handleMoveTestStep, isMoving: isMovingTestStep } = useHandleMoveTestStep();
  const { recorderState, updateLiveState } = useLiveStateManager();

  const handleOnDrop: ComponentProps<typeof DragDropProvider>['onDragEnd'] = async (event) => {
    const actionItem = event.operation.source?.data;
    const dropZone = event.operation.target?.data;

    // oxlint-disable-next-line no-restricted-syntax
    switch (actionItem?.type) {
      case 'moveStep':
        return handleMoveTestStep(actionItem, dropZone);
      case 'operation':
        if (dropZone && recorderState?.operation?.id === actionItem.operationId) {
          updateLiveState((prev) => ({
            ...prev,
            recorderCursor: {
              stepId: dropZone.targetStepId,
              stepOrder: dropZone.insertAfterStepOrder,
              operation: {
                id: actionItem.operationId,
                order: dropZone.targetNextOperationId,
              },
            },
          }));
        }
        return handleMoveOperation(actionItem, dropZone);
      default:
        console.error('Invalid drop event type', { source: actionItem, target: dropZone });
    }
  };

  return { handleOnDrop, isMoving: isMovingOperation || isMovingTestStep };
}
